import React, { useState } from 'react';
import Notes from 'src/common/components/notes';
import { sizes } from 'src/styles/Media.styled';
import { TextBold, OrderDetailTabBodyContainer } from './index.styled';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import { useSelector, useDispatch } from 'react-redux';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import UnsavedChanges from 'src/pages/scheduleSurgery/components/surgery/notifications/UnsavedChanges';
import {
    setUnsavedChangePhysician,
    setCommonCancel,
    updatePhysicianNotes,
    setTemplateNote,
    setTemplateNoteChangePhysician,
    setShowUnsavedPhysician,
} from 'src/pages/more/redux/actions';
import {
    FIA_USER_ROLE,
    FIM_USER_ROLE,
    ITA_USER_ROLE,
} from 'src/constants/appConstants';
import AddedMoreThanTenItems from 'src/pages/equity/components/surgery/notifications/AddedMoreThanTenItems';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util';

const AccountNotes = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [textAreaCharLimit] = useState(4000);
    const isIPadPro =
        typeof window !== 'undefined' &&
        window.innerWidth >= 1024 &&
        window.innerWidth <= 1366;
    const physicianNotes = useSelector(
        (state) => state.accountReducer.physicianNotes
    );
    const [isCancel, setisCancel] = useState(false);
    const [templateNotesPopup, setTemplateNotesPopup] = useState(false);
    const { saved, setSaved } = props;
    const templateNote = useSelector(
        (state) => state.accountReducer.templateNotePhysician
    );
    const onKeyboardOpenHandler = () => {
        document.body.scrollTop = 0;
        window.onscroll = function () {
            window.scrollTo(0, 0);
        };
    };
    useEffectWithErrorLogging(() => {
        window.visualViewport.addEventListener('resize', onKeyboardOpenHandler);
        window.visualViewport.addEventListener('scroll', onKeyboardOpenHandler);
        return () => {
            window.visualViewport.removeEventListener(
                'resize',
                onKeyboardOpenHandler
            );
            window.visualViewport.removeEventListener(
                'scroll',
                onKeyboardOpenHandler
            );
        };
    }, []);

    useEffectWithErrorLogging(() => {
        if (physicianNotes && !templateNoteChange) {
            dispatch(setTemplateNote(physicianNotes));
        } else if (templateNoteChange) {
            dispatch(setTemplateNote(templateNote));
        } else {
            dispatch(setTemplateNote(''));
        }
    }, [physicianNotes]);

    const handleNote = (note) => {
        setSaved(false);
        dispatch(setCommonCancel(false));
        // dispatch(setUnsavedChange(true));
        if (templateNote !== note) {
            dispatch(setTemplateNoteChangePhysician(true));
            dispatch(setUnsavedChangePhysician(true));
        }
        const lengthOfNote = note.length;
        if (lengthOfNote <= 4000) {
            dispatch(setTemplateNote(note));
        } else {
            const sliceLastIdx = 4000 - lengthOfNote;
            dispatch(setTemplateNote(note.slice(0, sliceLastIdx)));
            setTemplateNotesPopup(true);
        }
    };

    const closekeyBoard = () => {
        document.activeElement.blur();
    };

    const handlePopupOnKeyPress = () => {
        if (templateNote.length >= 4000) {
            setTemplateNotesPopup(true);
            closekeyBoard();
        }
    };

    const handleClick = (e) => {
        e.preventDefault();
        setTemplateNote('');
        // Safety check - don't execute if button should be disabled
        if ((templateNote && templateNote.length === 0) || !templateNoteChange || saved) {
            return;
        }
        
        dispatch(setUnsavedChangePhysician(false));
        setSaved(true);
        dispatch(setTemplateNoteChangePhysician(false));
        if (props.fromPhysician) {
            const requestBody = {
                notes: templateNote,
                physicianId: props.physician.physicianId,
            };
            dispatch(updatePhysicianNotes(requestBody));
        }
    };

    const templateNoteChange = useSelector(
        (state) => state.accountReducer.templateNoteChangePhysician
    );

    const onCancel = () => {
        if (templateNoteChange) {
            setisCancel(true);
        }
        // if (templateNote.length > 0) setisCancel(true);
        // else props.onClose();
    };
    const handleDiscardChanges = () => {
        physicianNotes
            ? dispatch(setTemplateNote(physicianNotes))
            : dispatch(setTemplateNote(''));
        setisCancel(false);
        dispatch(setTemplateNoteChangePhysician(false));
        dispatch(setUnsavedChangePhysician(false));
        dispatch(setShowUnsavedPhysician(false));
    };
    const handleSaveAndExit = () => {
        setisCancel(false);
        dispatch(setShowUnsavedPhysician(false));
        dispatch(setUnsavedChangePhysician(true));
    };
    const fromSettingsClose = () => {
        setisCancel(false);
    };

    const placeholderText =
        t('more.common.enternote');
    return (
        <>
            <OrderDetailTabBodyContainer>
                <Notes
                    className="more-physician-note-text-dt-mask"
                    height={'unset'}
                    contentBodyBackground={'none'}
                    backGround={'none'}
                    borderRadius={'0'}
                    border={'none'}
                    margin={'0'}
                    boxShadow={'none'}
                    contentBodyMargin="0"
                    cardFooterMargin="5px 0 0 5px"
                    note={templateNote}
                    placeholder={placeholderText}
                    updateNotes={handleNote}
                    helperText={`${
                        4000 - templateNote?.length < 0
                            ? 0
                            : 4000 - templateNote?.length
                    } ${t('equity.surgery.remainchar')}`}
                    fontSize="14px"
                    rows="8"
                    maxLength={textAreaCharLimit}
                    onKeyPress={handlePopupOnKeyPress}
                    // textAreaDisabled={physicianNotes ? true : false}
                    textAreaDisabled={
                        props.employeeRole == FIM_USER_ROLE ||
                        props.employeeRole == FIA_USER_ROLE ||
                        props.employeeRole == ITA_USER_ROLE
                    }
                />
                {templateNotesPopup ? (
                    <AddedMoreThanTenItems
                        title={t('equity.surgery.charLimit')}
                        onClose={() => {
                            try {
                                setTemplateNotesPopup(false);
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                        opacity={'1'}
                        zIndex={999999999}
                        background={'#000000cc 0% 0% no-repeat padding-box'}
                    />
                ) : null}
            </OrderDetailTabBodyContainer>
            {props.employeeRole !== FIM_USER_ROLE &&
                props.employeeRole !== ITA_USER_ROLE &&
                props.employeeRole !== FIA_USER_ROLE && (
                    <BottomNavigation
                        isIPadPotrait={true}
                        iPadPortraitFooterPosition={'fixed'}
                        opacity={'1'}
                        border={'1px solid #1010EB'}
                        // borderRadius={'25px'}
                        position={'absolute'}
                        buttonsPosition={'fixed'}
                        smalDeviceJustifyContent={'flex-end'}
                        padding={'11px 25px 11px 25px !important'}
                        justifyContent={'flex-end'}
                        moblieJustifyContent={'center'}
                        bottom={isIPadPro ? '0' : '5%'}
                        left={'0'}
                        right={isIPadPro ? '0%' : '6%'}
                    >
                        <Button
                        id={'physicianDetails-physicianNotes-cancelButton'}
                            show={true}
                            // secondary={true}
                            variant={ButtonStyles?.secondary}
                            border={'1px solid #140F4B'}
                            top={'659px'}
                            color={'#140F4B'}
                            left={'670px'}
                            width={'131px'}
                            mobileWidth={'160px'}
                            height={'38px'}
                            margin={
                                window.innerWidth <= sizes.mobileDevice
                                    ? '0px 6px 0px 0px'
                                    : '0px 20px 0px 0px'
                            }
                            clicked={onCancel}
                        >
                            <TextBold color={'#140F4B'}>{t('more.common.cancel')}</TextBold>
                        </Button>
                        <Button
                        id={'physicianDetails-physicianNotes-saveButton'}
                            show={true}
                            // primary={
                            //     templateNoteChange && !saved ? true : false
                            // }
                             disabled={
                                (templateNote && templateNote.length === 0) ||
                                !templateNoteChange ||
                                saved
                            }
                            variant={
                                templateNoteChange && !saved && templateNote && templateNote.length > 0
                                    ? ButtonStyles?.primary
                                    : ButtonStyles?.disabled
                            }
                            // disabledSaveBtn={
                            //     (templateNote && templateNote.length === 0) ||
                            //     !templateNoteChange ||
                            //     saved ||
                            //     physicianNotes
                            //         ? true
                            //         : false
                            // }
                           
                            top={'659px'}
                            left={'670px'}
                            width={'131px'}
                            mobileWidth={'160px'}
                            height={'38px'}
                            clicked={handleClick}
                        >
                            <TextBold color={'#FFFFFF'}>{t('more.common.save')}</TextBold>
                        </Button>
                    </BottomNavigation>
                )}
            {isCancel && !saved ? (
                <UnsavedChanges
                    onDiscard={handleDiscardChanges}
                    onClose={handleSaveAndExit}
                    continueText={t('more.common.conedit')}
                    fromSettingsClose={fromSettingsClose}
                    fromMore={true}
                />
            ) : null}
        </>
    );
};
export default AccountNotes;
